import { useState, useCallback, useMemo } from 'react';

export const useModal = <T = unknown,>(openOnMount = false) => {
  const [isOpen, setIsOpen] = useState(openOnMount);
  const [data, setData] = useState<T | undefined>();

  const open = useCallback((data?: T) => {
    if (data) {
      setData(data);
    }
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);
  const toggle = useCallback((openState: boolean, data?: T) => {
    if (data) {
      setData(data);
    }
    setIsOpen(openState);
  }, []);

  return useMemo(
    () => ({
      data,
      isOpen,
      open,
      close,
      setData,
      toggle
    }),
    [close, data, isOpen, open, toggle]
  );
};
